module.exports = __webpack_public_path__ + "static/media/shuzhihua3.a77749b5.png";